/**
 * Adjusts a namespace object to allow interoperation between
 * Node.js native ESM and Babel's ESM transpilation.
 *
 * @param ns the namespace object provided by Node.js
 * @param loose skip checking the existence of `ns.__esModule`.
 *        This is useful when cjs-module-lexer is unable to detect the
 *        definition of `__esModule`.
 * @returns the adjusted namespace object
 * @example
 *   ```ts
 *   import * as nsOrig from "mod";
 *   const ns = interopImportCJSNamespace(nsOrig);
 *   console.log([ns.foo, ns.default]);
 *   ```
 */
export function interopImportCJSNamespace(ns, loose) {
  return (loose || ns.__esModule) && ns.default && ns.default.__esModule ? ns.default : ns;
}
/**
 * Adjusts a default imported object to allow interoperation between
 * Node.js native ESM and Babel's ESM transpilation.
 *
 * @param d the default imported object provided by Node.js
 * @returns the adjusted default imported object
 * @example
 *   ```ts
 *   import valueOrig from "mod";
 *   const value = interopImportCJSDefault(value);
 *   console.log(value);
 *   ```
 */

export function interopImportCJSDefault(d) {
  return d && d.__esModule ? d.default : d;
}